export default "__VITE_ASSET__C_$lULCV__"